import * as Yup from 'yup';
import { Utils } from '@gv/triage-components';

export interface FormValues {
  email: string;
  password: string;
}

export const validationSchema = Yup.object().shape({
  password: Utils.Validation.password,
  email: Yup.string().email('Email is not valid'),
});

export const getInitialValues = (): FormValues => {
  return {
    password: '',
    email: Utils.Storage.getRememberedEmail() ?? '',
  };
};
